import { render, staticRenderFns } from "./PlaceholderField.vue?vue&type=template&id=fbf241a6&scoped=true"
import script from "./PlaceholderField.vue?vue&type=script&lang=ts"
export * from "./PlaceholderField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf241a6",
  null
  
)

export default component.exports